import React from "react";
import PropTypes from "prop-types";
import css from "../../css/find-agent/blog.module.css";
import BlogPost from "./BlogPost";

class BlogList extends React.PureComponent {
    render() {
        return (
            <div className={css.blog}>
                {this.props.blogs.map((blog) => {
                    return <BlogPost blog={blog} key={blog.id} />;
                })}
            </div>
        );
    }
}

BlogList.propTypes = {
    blogs: PropTypes.array.isRequired,
};

export default BlogList;
